import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
export const getReportlist = (searchItem) => {
  let url = `${API.ReportAPI}?vesselname=${searchItem.vesselname}&minyear=${searchItem.minyear}&maxyear=${searchItem.maxyear}&pagesize=${searchItem.pagesize}&pagenumber=${searchItem.pagenumber}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        console.log("head",response.headers)
        if(response.data==="An exception has been raised that is likely due to a transient failure."){
          dispatch({
            type: "GetReportListSuccess",
            data: "",
          })
        }else{
          dispatch({
            type: "GetReportListSuccess",
            data: response.data,
          })
        }
      
        dispatch({
          type: "GetReportCountListSuccess",
          data: response.headers["X-Pagination"],
        })
        

      })
      .catch((error) => {
        dispatch({
          type: "GetReportFailure",
          error: "ERROR"
        })
      })
  }
}
export const exportReportPDF = (searchItem) => {
  let url = `${API.ExportReportAPI}?vesselName=${searchItem.vesselname}&fromDate=${searchItem.minyear}&toDate=${searchItem.maxyear}`;
  return dispatch => {
    axios.get(url,{responseType:"blob"})
      .then((response) => {
       let blob='';
       blob=new Blob([response.data],{type:response.data.type});
       FileSaver.saveAs(blob,searchItem.vesselname);
      })
      .catch((error) => {
        dispatch({
          type: "ExportReportFailure",
          error: "ERROR"
        })
      })
  }
}